import React from "react";
import { Link } from "react-router-dom";

export default function ProductionHero({ service }) {
    return (
        <section className="production-hero">
            <div className="production-hero-media">
                <img src={service.image} alt={service.imageAlt} />
            </div>
            <div className="production-hero-content">
                <div className="production-bread">
                    <Link to="/">Inicio</Link>
                    <span>/</span>
                    <Link to="/servicios">Servicios Empresariales</Link>
                    <span>/</span>
                    <strong>Producción y Eventos</strong>
                </div>
                <span className="production-tag">Servicio empresarial</span>
                <h1>Producción de contenido y <span>cobertura de eventos</span></h1>
                <p>{service.subtitle}</p>
                <div className="production-hero-actions">
                    <a href="#produccion-servicios">Ver servicios →</a>
                    <a href="#contacto">Contactar</a>
                </div>
            </div>
        </section>
    );
}
